module.exports = __webpack_public_path__ + "static/media/VideoRecord.67d502ea.ogg";